import GeneratedEntryLinkStore from "./generated/GeneratedEntryLinkStore"

class EntryLinkStore extends GeneratedEntryLinkStore {

}

export const entryLinkStore = new EntryLinkStore()
